.container {
  width: 100%;
  position: relative;
  padding: 20px;
}

.tooltip {
  position: absolute;
  pointer-events: none;
  background: white;
  border-radius: 4px;
  padding: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 120px;
  z-index: 10;
  transform: translate(-50%, -100%);
  margin-top: -10px;
}

.tooltipHeader {
  font-size: 14px;
  font-weight: 500;
  color: var(--dark-80);
  margin-bottom: 4px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--dark-10);
}

.tooltipContent {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 12px;

  span:first-child {
    color: var(--dark-60);
  }

  span:last-child {
    color: var(--dark-80);
    font-weight: 500;
  }
}
